// src/App.js
import "./styles/index.scss";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import Popup from "../components/popup/Popup";

const MainPage = lazy(() => import("../pages/mainPage/MainPage"));
const TrainingsPage = lazy(
  () => import("../pages/trainingsPage/TrainingsPage"),
);
const InfoPage = lazy(() => import("../pages/infoPage/infoPage"));
const ReviewsPage = lazy(() => import("../pages/reviewsPage/ReviewsPage"));
const ContactsPage = lazy(() => import("../pages/contactsPage/ContactsPage"));
const NotFoundPage = lazy(() => import("../pages/notFoundPage/NotFoundPage"));

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="loading-spinner__animation"></div>
    <p className="loading-spinner__text">Загрузка...</p>
  </div>
);

const App = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [headerHeight, setHeaderHeight] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const isNotFoundPage =
    location.pathname !== "/" &&
    location.pathname !== "/training" &&
    location.pathname !== "/info" &&
    location.pathname !== "/reviews" &&
    location.pathname !== "/contacts";

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector("header");
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);

  const handleFormSubmit = (formData) => {
    console.log("Form submitted:", formData);
  };

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Реутовская автошкола водительского мастерства</title>
        <meta
          name="description"
          content="Автошкола в Реутове - качественное обучение вождению, профессиональные инструкторы, современные методики обучения. Категории A, B, М. Подготовка к экзаменам в ГИБДД."
        />
        <meta
          name="keywords"
          content="автошкола Реутов, обучение вождению, курсы вождения, права категории B, инструктор по вождению, автошкола Москва"
        />
        <meta
          property="og:title"
          content="Реутовская автошкола водительского мастерства"
        />
        <meta
          property="og:description"
          content="Уверенное вождение начинается здесь! Профессиональное обучение вождению в Реутове."
        />
        <meta property="og:type" content="website" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {isNotFoundPage && (
          <title>404 - Страница не найдена | Реутовская автошкола</title>
        )}
      </Helmet>

      <div className={`app ${isHomePage ? "app--home" : ""}`}>
        <div className="mainContent">
          {!isNotFoundPage && <Header onOpenPopup={handleOpenPopup} />}

          <main
            className="main-content"
            style={{
              paddingTop: !isNotFoundPage ? `${headerHeight}px` : "0",
              transition: "padding-top 0.3s ease",
            }}
          >
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route
                  path="/"
                  element={<MainPage onOpenPopup={handleOpenPopup} />}
                />
                <Route path="/training" element={<TrainingsPage />} />
                <Route
                  path="/info"
                  element={<InfoPage onOpenPopup={handleOpenPopup} />}
                />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </main>

          {!isNotFoundPage && <Footer onOpenPopup={handleOpenPopup} />}
        </div>
      </div>
      <Popup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        onFormSubmit={handleFormSubmit}
      />
    </>
  );
};

export default App;
